import "../../styles/results/list.scss";

import * as noUiSlider from "nouislider";
import axios from "axios";
import { bind_swiper } from "../integration/swiper";
import "./mobile-slideout-options";
import dayjs from "dayjs";
import "dayjs/locale/af";
import "dayjs/locale/en";
import MoveTo from "moveto";
import { isEmpty } from "validate.js";
import { initializePopovers } from "../general/initialize-popover";
import { shareFallback } from "../establishments/components/share";
import 'formdata-polyfill'
import '../favourites/favourites-settings'
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import { debounce } from "../main.entry";

const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

/**
 *
 * Variables
 */
let cancelToken;
let roomFilterCancelToken; // Separate cancel token for room filter requests
let state = "push";
let timeDifference = 0; // Measures the time difference for results request to control placeholder animation
let old_page = 1;
let form = document.getElementById("form-sidebar-filters");
let filterData = serializeForm(form);
let urlString = '';
let initial_order = 0;

let oldAdultAllocation = Alpine.store('search').allocation.adult.value;
let oldChildAllocation = Alpine.store('search').allocation.child.value;

const priceSlider = document.getElementById("js-filter-price-slider");
const inputMin = document.getElementById("js-filter-price-input-min");
const inputMax = document.getElementById("js-filter-price-input-max");
const {
    site,
    site_name,
    page_arguments,
    page_name,
    language_switch,
    pikaday_i18n_en,
    pikaday_i18n_af,
    is_mobile_device,
    is_app,
    is_vm,
    mobile_os,
    is_desktop_device
} = window.tg;


const vw = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
);
const mobile_safety =
    is_mobile_device === true || vw < 440 || is_app ? true : false; // Fallback safety in case mobile device wrongly detected DEV-6156, DEV-6354 added is_app for additional fallback


const dateRequiredFilters = [
    "price-high",
    "price-low",
    "from_price",
    "to_price",
    "reviews",
];

let endMinDate = new Date();

let serialize = function (obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + obj[p]);
        }
    return str.join("&");
};

function serializeForm(form) {
    const obj = {};
    if (!form || form.nodeName !== "FORM") {
        return obj
    }
    const formData = new FormData(form);

    for (const key of formData.keys()) {
        obj[key] = formData.getAll(key);
    }

    return obj;
}

window.resetRequiredFilters = function () {
    inputMax.value = inputMax.getAttribute('data-default')
    inputMin.value = inputMin.getAttribute('data-default')
    inputMax.setAttribute("disabled", "");
    inputMin.setAttribute("disabled", "");
    priceSlider.noUiSlider.set([inputMin.value, inputMax.value])
    form.querySelector('input[name="sort"][value="recommended"').checked = true
    if (site == 'vy') {
        Alpine.store('results').sort.items.forEach((item, index) => {
            item.selected = item.value == 'recommended'
        })
    }
}


let resetFilters = function () {
    let pensionerSession = form.querySelector('#Filter-User-Type-Pensioner');
    let pensionerSessionChecked = false;

    if (pensionerSession) {
        pensionerSessionChecked = pensionerSession.checked;
    }

    // Reset any other values than checked
    form.reset()

    inputMax.setAttribute("disabled", "");
    inputMin.setAttribute("disabled", "");

    // Reset checked values
    let inputEls = form.querySelectorAll('input')

    // Don't reset pensioner session when resetting all filters
    inputEls.forEach(el => {
        if (el.id !== 'Filter-User-Type-Pensioner') {
            el.checked = false;
        } else {
            el.checked = pensionerSessionChecked;
        }
    })

    let sortInput = form.querySelector('#Sort-ranking')
    if (sortInput) {
        sortInput.checked = true;
    }

    if (site == 'vy') {
        Alpine.store('results').sort.items.forEach((item, index) => {
            item.selected = item.value == 'recommended'
        })
    }

    // Clear any filterData
    filterData = {}
}

let simulateClick = function (elem) {
    // Create our event (with options)
    var evt = document.createEvent("MouseEvent");
    evt.initMouseEvent(
        "click",
        true /* bubble */,
        true /* cancelable */,
        window,
        null,
        0,
        0,
        0,
        0 /* coordinates */,
        false,
        false,
        false,
        false /* modifier keys */,
        0 /*left*/,
        null
    );

    let canceled = !elem.dispatchEvent(evt);
};

// Simple onChange dispatch event to trigger waterfall when input value changes via javascript
let dispatchEventChange = function (elem) {
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("change", false, true);
    elem.dispatchEvent(evt);
};

let caculatesearchNextStep = function (origin = "results") {
    Alpine.store('search').houseKeeping();
};

// Intersection observer for infinite loading
const infiniteLoad = site == 'vy';

// Viya specific js
if (site == 'vy') {
    const el = document.querySelector(".bar-container")
    const observer = new IntersectionObserver( handleIntersect,
    { threshold: [1] }
    );
    if (el !== null) {
        observer.observe(el);
    }
}
function handleIntersect(entries) {
    entries.forEach((entry) => {
        Alpine.store('general').sticky.bar = entry.intersectionRatio < 1;
        if (entry.intersectionRatio < 1) {
            Alpine.store('general').updateOpenSection('NONE');
        }
    });
}


/**
 *
 * Actions
 */

bind_swiper(".js-swiper-main");

if (site == 'vy' || (site == 'ls' && window.tg.ab_test_data.vertical_snippet == 'new')) {
    setTimeout(function () {
        showPlaceHolder(false)
    }, 200)
}

    form.addEventListener("change", onChangeHandler.bind(this));

if (priceSlider) {
    noUiSlider.create(priceSlider, {
        connect: true,
        margin: 100,
        behaviour: "drag-tap",
        start: [
            parseInt(priceSlider.dataset.fromValue),
            parseInt(priceSlider.dataset.toValue),
        ],
        range: {
            min: [parseInt(priceSlider.dataset.min), 50],
            '25%': [parseInt(parseInt(priceSlider.dataset.max) * 1 / 10), 50],
            '75%': [parseInt(parseInt(priceSlider.dataset.max) * 4 / 10), 50],
            max: [parseInt(priceSlider.dataset.max), 50],
        },
        tooltips: [
            {
                from: Number,
                to: function (value) {
                    const selection = Math.round(value / 50) * 50;
                    return `R${selection}`;
                },
            },
            {
                from: Number,
                to: function (value) {
                    const selection = Math.round(value / 50) * 50;
                    if (selection == priceSlider.dataset.max) {
                        return `R${selection}+`;
                    }
                    return `R${selection}`;
                },
            },
        ],
    });

    priceSlider.noUiSlider.on("change", function (values, handle) {
        // Handle 0 is minimum, Handle 1 is maximum
        let value = parseInt(values[handle]);

        if (handle == 0) {
            inputMin.value = value;
            if (value === parseInt(priceSlider.dataset.min)) {
                inputMin.setAttribute("disabled", "");
            } else {
                inputMin.removeAttribute("disabled");
            }

            inputMin.dispatchEvent(new Event("change", { bubbles: true }));
            return;
        }

        if (handle == 1) {
            inputMax.value = value;

            if (value === parseInt(priceSlider.dataset.max)) {
                inputMax.setAttribute("disabled", "");
            } else {
                inputMax.removeAttribute("disabled");
            }

            inputMax.dispatchEvent(new Event("change", { bubbles: true }));
            return;
        }
    });
}

/**
 *
 * Functions
 */

// Create debounced version of fetchResults for room amenities to prevent rapid-fire requests
const debouncedFetchResults = debounce((type, event) => {
    fetchResults(type, event, 1, true); // Pass true to indicate this is a room filter request
}, 500); // 500ms delay

// Track pending room filter state
let roomFilterPending = false;
let roomFilterClickCount = 0;
let roomFilterDebounceStart = null;

function onChangeHandler(event) {
    // Check if this is a room amenities filter change
    const isRoomAmenityFilter = event.target.name === 'room_amenities_filter';

    const isPricePerNightFilterActive = inputMin.value != inputMin.getAttribute("data-default") || inputMax.value != inputMax.getAttribute("data-default");
    const noDatesSelected = Alpine.store('search').start.length == 0 && Alpine.store('search').end.length == 0;

    const isRecommendedSortWithPricePerNight = event.target.name === 'sort' && event.target.value === 'recommended' && isPricePerNightFilterActive && noDatesSelected;

    if (isRecommendedSortWithPricePerNight) {
        inputMax.value = inputMax.getAttribute('data-default')
        inputMin.value = inputMin.getAttribute('data-default')
        inputMax.setAttribute("disabled", "");
        inputMin.setAttribute("disabled", "");
        priceSlider.noUiSlider.set([inputMin.value, inputMax.value])

        toggleMobileTraySort(event)
    }

    if (
        Alpine.store('search').start.length == 0 &&
        Alpine.store('search').end.length == 0 &&
        (dateRequiredFilters.indexOf(event.target.value) !== -1 ||
            dateRequiredFilters.indexOf(event.target.name) !== -1)
    ) {

        // Close any open slideout options
        const slideoutOptions = document.getElementById("slideout-options");
        if (slideoutOptions && slideoutOptions.classList.contains("show")) {
            slideoutOptions.classList.remove("show");
        }

        Alpine.store('search').datesRequired = true
        let teleportTo = Alpine.store('general').sticky.bar ? 'BAR' : is_mobile_device ? 'MOBILE' : 'DESKTOP';

        Alpine.nextTick(() => {
            if (Alpine.store('general').openSection == 'TRAY') {
                Alpine.store('general').updateOpenTray('NONE');
                setTimeout(() => {
                    Alpine.store('general').updateSearchTeleport(teleportTo)
                    Alpine.store('general').updateOpenSection('SEARCH')
                }, 180);
            } else {
                Alpine.store('general').updateSearchTeleport(teleportTo)
                if (Alpine.store('general').openSection != 'SEARCH') {

                    if (is_mobile_device) {
                        clearAllBodyScrollLocks();
                    }

                    Alpine.store('general').updateOpenSection('SEARCH')
                }
            }

            setTimeout(() => {
                Alpine.store('search').houseKeeping('start');
                toggleMobileTraySort(event)
            },250)
        })
    } else {
        toggleMobileTraySort(event)

        // Use debounced version for room amenities filters to prevent rapid-fire requests
        if (isRoomAmenityFilter) {
            debouncedFetchResults("search", "on_change");
        } else {
            // Use normal immediate fetch for other filters
            fetchResults("search", "on_change");
        }
    }
}

function toggleMobileTraySort(event){
    if (event.target.name == 'sort' && event.target.classList.contains('bordered-sort-item')) {
        let selectedSortEl = event.target.parentElement
        let currentSortEl = selectedSortEl.parentElement.parentElement.querySelector('.active')

        if (currentSortEl != null) {
            currentSortEl.classList.remove('border-primary', 'active')
            currentSortEl.classList.add('border-gray-400')
        }

        selectedSortEl.classList.remove('border-gray-400')
        selectedSortEl.classList.add('border-primary', 'active')
    }
}

window.fetchResults = function fetchResults(type = "search", event = "", page = 1, isRoomFilter = false) {
    // Cancel previous requests
    if (typeof cancelToken != typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    // If this is a room filter request, cancel any previous room filter requests
    if (isRoomFilter && typeof roomFilterCancelToken != typeof undefined) {
        roomFilterCancelToken.cancel("Room filter operation canceled due to new request.");
    }

    const t0 = performance.now();

    if (Alpine.store('search').allocation.adult.value != oldAdultAllocation || Alpine.store('search').allocation.child.value != oldChildAllocation) {
        updateInputMax()
    }

    filterData = serializeForm(form);

    if (isEmpty(filterData)) {
        filterData = {
            sort: 'recommended'
        }
    }

    if (! window.document.documentMode) {
        try {
            const queryString = window.location.search;
            let urlParams = Object.fromEntries([...new URLSearchParams(queryString)]);
            delete urlParams["page_number"];
            delete urlParams["clear"];

            if (!isEmpty(urlParams)) {
                let inputEls = form.querySelectorAll('input')
                inputEls.forEach(el => {
                    delete urlParams[el.name];
                });
                filterData = Object.assign({}, filterData, urlParams);
            }
        } catch (e) {}
    }

    if (Alpine.store('search').start.length > 0 && Alpine.store('search').end.length > 0) {
        filterData = {
            ...filterData,
            start: Alpine.store('search').start,
            end: Alpine.store('search').end,
        };
        filterData = {
            ...filterData,
            room: Alpine.store('search').allocation.room.value,
            adult: Alpine.store('search').allocation.adult.value,
            child: Alpine.store('search').allocation.child.value,
            child_ages: Alpine.store('search').allocation.child_ages.value.join(','),
            pax: Alpine.store('search').allocation.adult.value
        }

        if (window.location.href.includes('redirect_source=google-hotels')) {
            filterData = {
                ...filterData,
                pax: Alpine.store('search').allocation.adult.value,
                number_adults: Alpine.store('search').allocation.adult.value,
                number_children: Alpine.store('search').allocation.child.value,
            }
        }
    }


    if (page !== 1) {
        filterData = {
            ...filterData,
            page_number: page,
        };
    }

    if (old_page != 1 && page == 1) {
        const moveTo = new MoveTo({
            tolerance: infiniteLoad ? 100 : 0,
            duration: 50,
            easing: "easeOutQuart",
            container: window,
        });
        moveTo.move(document.getElementById("section-top"));
    }

    old_page = page;

    if (type === "clear-all") {
        resetFilters();
        filterData = {
            clear: 1
        };

    } else if (type === "clear-filters") {
        resetFilters();
        filterData = {
            clearFilter: 1
        }
    }

    if (Alpine.store('search').membership.length > 0) {
        filterData = {
            ...filterData,
            partner_membership: Alpine.store('search').membership
        }
    }

    if (type == "search-infinite-load") {
        filterData = {
            ...filterData,
            appendResults: 1
        }
    }

    if (!isEmpty(event)) {
        filterData = {
            ...filterData,
            event: event
        }
    }

    // Create appropriate cancel token
    if (isRoomFilter) {
        roomFilterCancelToken = axios.CancelToken.source();
        cancelToken = roomFilterCancelToken;
    } else {
        cancelToken = axios.CancelToken.source();
    }

    const queryString = serialize(filterData);

    urlString = `/backend/${ page_name === 'results.attraction' ? 'attraction' : 'results' }/list/${page_arguments.which}`;

    if (page_arguments.hasOwnProperty('filter1') && page_arguments.filter1 != '') {
        urlString += `/${page_arguments.filter1}`;
    }

    urlString += `?${queryString}`;


    if (page_name === 'results.favourites.list') {
        urlString =  `/backend/favourites/${page_arguments.filter1}?${queryString}`;
    }

    if (type != "search-infinite-load") {
        showPlaceHolder(true);
    }

    axios({
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "get",
        url: urlString,
        cancelToken: cancelToken.token,
    })
        .then(function (response) {
            const t1 = performance.now();
            timeDifference = t1 - t0;

            // Update search_event_id from response
            if (response.data && response.data.search_event_id) {
                window.tg.search_event_id = response.data.search_event_id;
            }

            setTimeout(() => {
                oldAdultAllocation = Alpine.store('search').allocation.adult.value;
                oldChildAllocation = Alpine.store('search').allocation.child.value;
                updateResults(response.data, type);
                logLocaleStorageClickData(response.data.log_result_click);

                // Clear filter pending state if this was a room filter request
                if (isRoomFilter || roomFilterPending) {

                    // Reset debounce tracking
                    if (roomFilterDebounceStart) {
                        roomFilterDebounceStart = null;
                        roomFilterClickCount = 0;
                    }
                }

                if (['clear-all', 'clear-filters'].includes(type) || (type === 'search' && !(filterData.hasOwnProperty('to_price') || filterData.hasOwnProperty('from_price')))) {
                    if (type == 'clear-all') {
                        Alpine.store('search').reset()
                    }

                    priceSlider.noUiSlider.set([inputMin.getAttribute('data-default'), inputMax.getAttribute('data-default')])
                }

                initializePopovers();
            }, 1000 - timeDifference); // Adding a delay of minimum one second else the animations for placeholders looks bad, negative delays are ignore by HTML5. Minimum is 4ms
        })
        .catch(function (error) {
            if (axios.isCancel(error)) {
                console.log("Request canceled", error.message);
            } else {
                showPlaceHolder(false);
            }
            return false;
        });
}

function updateInputMax() {
    let adult = Alpine.store('search').allocation.adult.value
    let child = Alpine.store('search').allocation.child.value

    let allocation = adult + child
    let oldAllocation = oldAdultAllocation + oldChildAllocation

    if ((allocation < oldAllocation && parseInt(inputMax.value) / allocation > 2500) || (allocation > oldAllocation && parseInt(inputMax.value) / oldAllocation == 2500)) {
        inputMax.value = allocation * 2500;
        inputMax.setAttribute('data-default', allocation * 2500)
        inputMax.setAttribute("disabled", "");
    }

}

function setAvailabilityButton(value) {
    if (value === "clear") {
        searchBtn.textContent = language_switch == 'en' ? "Clear Dates" : "Verwyder datums"; // Hardcoded as unsure why kd.global is not working
        searchBtn.setAttribute("data-action", "clear-all");
    } else {
        searchBtn.textContent = language_switch == 'en' ? "Check availability" : "Kyk beskikbaarheid"; // Hardcoded as unsure why kd.global is not working
        searchBtn.setAttribute("data-action", "search");
    }
}


function showPlaceHolder(show = true) {
    Alpine.store('search').loading = show;

    let placeholderListEl = document.querySelector(".kd--loading_placeholder");
    let resultsListEl = document.getElementById("js-list-establishments");

    if (show && placeholderListEl.classList.contains("d-none")) {
        placeholderListEl.classList.remove("d-none");
        resultsListEl.classList.add("d-none");
        return;
    }
    if (!show && resultsListEl.classList.contains("d-none")) {
        placeholderListEl.classList.add("d-none");
        resultsListEl.classList.remove("d-none");
    }
}
function updateResults(data, type) {
    showPlaceHolder(false);

    let additionalData = data.additional_data

    // loop through additionalData keys and update the store
    for (const [key, value] of Object.entries(additionalData)) {
        Alpine.store('results')[key] = value;
    }

    // Parse html for computation
    let parser = new DOMParser();
    let htmlDoc = parser.parseFromString(data.html, "text/html");
    let children = htmlDoc.body.children;

    let sectionTop = children.namedItem("section-top");
    let sectionBody = children.namedItem("section-body");

    // if (site == 'vy') {
    //     let sectionInnerBody = sectionBody.children.namedItem("section-inner-body");
    //     let listEstablishments = sectionInnerBody.children.namedItem('js-list-establishments')
    //     let listEstablishmentsContainer = document.getElementById("js-list-establishments")

    //     listEstablishmentsContainer.innerHTML = ''
    //     // reset number to 1
    //     document.querySelector('.pagination__next').setAttribute('data-next', 1)

    //     for (let child of listEstablishments.children) {
    //         listEstablishmentsContainer.appendChild(child.cloneNode(true))
    //     }
    // } else {
        if (document.getElementById("section-top") != undefined) {
            document.getElementById("section-top").outerHTML = sectionTop.outerHTML;
        }
        document.getElementById("section-body").outerHTML = sectionBody.outerHTML;
    // }

    let priceFilter = additionalData.filters.find(x => x.key == 'price')
    let fromPrice = priceFilter.items.find(x => x.name == 'from_price')
    let toPrice = priceFilter.items.find(x => x.name == 'to_price')

    priceSlider.noUiSlider.updateOptions(
        {
            range: {
                min: [parseInt(fromPrice.range), 50],
                '25%': [parseInt(parseInt(toPrice.range) * 1 / 10), 50],
                '75%': [parseInt(parseInt(toPrice.range) * 4 / 10), 50],
                max: [parseInt(toPrice.range), 50],
            },
            tooltips: [
                {
                    from: Number,
                    to: function (value) {
                        const selection = Math.round(value / 50) * 50;
                        return `R${selection}`;
                    },
                },
                {
                    from: Number,
                    to: function (value) {
                        const selection = Math.round(value / 50) * 50;
                        if (selection == toPrice.range) {
                            return `R${selection}+`;
                        }
                        return `R${selection}`;
                    },
                },
            ],
        }
    )

    if (inputMax.value == inputMax.getAttribute('data-default')) {
        priceSlider.noUiSlider.set([null, toPrice.range])
    }

    let swiperClass = type == 'search-infinite-load' ? '.js-swiper-main:not(.swiper-container-initialized)' : '.js-swiper-main'
    bind_swiper(swiperClass);
    showPlaceHolder(false)
    setHistory();

    if (site == 'vy' || site == 'ls' ) {
      // smooth scroll to top
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
}

function setHistory() {

    if (infiniteLoad) {
        // TODO: check if not having page number in url is issue for SEO
        delete filterData['page_number'];
        delete filterData['appendResults'];
    }

    let pageNumber =
        parseInt(filterData["page_number"]) > 1
            ? parseInt(filterData["page_number"])
            : 1;
    let path = getPath(pageNumber);

    // Removing grading_filter from url when set to 0 since it's all
    if (filterData['grading_filter'] && filterData['grading_filter'] == 0) {
        delete filterData['grading_filter'];
    }

    if (filterData['event']) {
        delete filterData.event;
    }

    let queryString = serialize(filterData);

    // Add params since clear is not present
    if (queryString.indexOf("clear") === -1) {
        let q = queryString === "" ? "" : "?";
        path += `${q}${queryString}`;
    }

    if (state === "push") {
        initial_order += 1;
        history.pushState({ location: path, order: (initial_order), params: filterData }, "", `${path}`);
        return;
    }

    if (state === "replace") {
        history.replaceState({ location: path, order: initial_order, params: filterData }, "", `${path}`);
        state = "push";
        return;
    }
}


function logLocaleStorageClickData(data) {
    if (navigator.cookieEnabled && site == 'ls') {
        // Check if any data is stored currently
        let local = window.localStorage.getItem('logs-results-click');
        local = local != null ? JSON.parse(local) : {}

        // Only store new entries
        if (data != null && data.uuid != '' && local[data.uuid] === undefined) {
            local[data.uuid] = data;
            window.localStorage.setItem('logs-results-click', JSON.stringify(local));

            if (false && is_vm && data.establishments !== undefined) {
                console.table(data.establishments)
            }
        }
    }
}

function getPath(pageNumber) {
    const url = new URL(document.URL);

    let path = url.pathname;

    // Check if path ends in number
    let end = path.substring(path.lastIndexOf("/") + 1);
    let endsWithNumber = parseInt(end) > 0;

    // Strip path if ends with number
    path = endsWithNumber
        ? url.pathname.substring(0, url.pathname.lastIndexOf("/"))
        : path;

    var countSlashes = path.split("/").length - 1;

    if (page_name === 'results.favourites.list') {
        if (countSlashes === 1) {
            path +=  `/${page_arguments.filter1}`;
        }
        return path;
    }
    // Add new number if necessary
    path = pageNumber !== 1 ? `${path}/${pageNumber}` : path;

    return path;
}

// iOS prevent onload popstate
window.addEventListener('load', function () {
    setTimeout(function () {
        window.addEventListener('popstate', onpopstate, false);
    }, 0);
}, false);

// iOS prevent onload if order in history.state added via pushState does not match
if (window.history.state != null && window.history.state.order) {
    if (initial_order !== history.state.order) {
        window.addEventListener('popstate', onpopstate, false);
    }
}

window.addEventListener("popstate", function (event) {
    let popstate = event.state;
    let params = popstate != null && popstate.params != null ? popstate.params : {}

    for (const element of form.elements) {
        if (["radio", "checkbox"].includes(element.type)) {
            if (
                params.hasOwnProperty(element.name) &&
                [...params[element.name]].includes(element.value)
            ) {
                element.checked = true;
            } else {
                element.checked = false;
            }
        }
    }

    // Check if from_price or to_price in params, disable input to prevent reset
    inputMin.value = params.hasOwnProperty("from_price")
        ? parseInt(params.from_price)
        : inputMin.getAttribute("data-default");
    inputMax.value = params.hasOwnProperty("to_price")
        ? parseInt(params.to_price)
        : inputMax.getAttribute("data-default");

    if (inputMin.value == inputMin.getAttribute("data-default")) {
        inputMin.setAttribute("disabled", "");
    }

    if (inputMax.value == inputMax.getAttribute("data-default")) {
        inputMax.setAttribute("disabled", "");
    }


    state = "replace";
    fetchResults(
        "search",
        "popstate",
        params.hasOwnProperty("page_number") ? parseInt(params.page_number) : 1
    );
});

document.addEventListener(
    "submit",
    function (event) {
        // Capture the form element
        const formEl = /** @type {HTMLFormElement} */ (event.target);
        const btn_loader =
            '<div class="btn-loader"><div class="rect1"></div> <div class="rect2"></div> <div class="rect3"></div> <div class="rect4"></div> <div class="rect5"></div></div>';

        const allowedForms = ["js-search-form-results"];

        if (allowedForms.indexOf(formEl.id) !== -1) {
            event.preventDefault();
            let validate = true;
            showPlaceHolder();

            // Both start and end needs to be empty or have values
            if (start !== null && end === null) {
                validate = false;
            }
            // Both start and end needs to be empty or have values
            if (end !== null && start === null) {
                validate = false;
            }

            if (parseInt(child) != child_ages.length) {
                validate = false;
            }

            // Force dates to be picked if pax is not CCPrates default 2
            if (
                validate &&
                adult !== null &&
                parseInt(adult) !== 2 &&
                parseInt(child) !== 0 &&
                (start === null || end === null)
            ) {
                let datesWarningEl = document.createElement("div");
                datesWarningEl.textContent = _t(
                    "kd.global.select_dates",
                    "Please select dates to continue."
                );
                datesWarningEl.classList.add("alert", "alert-error", "ml-0");
                validate = false;
            }

            if (validate) {
                // Check if form has post url
                try {
                    if (formEl.action === "") {
                        throw "Form action is empty";
                    }

                    fetchResults(searchBtn.getAttribute("data-action"));
                } catch (e) {
                    showPlaceHolder(false);
                }
            } else {
                caculatesearchNextStep();
                showPlaceHolder(false);
            }
        }
    },
    false
);

document.addEventListener(
    "click",
    function (event) {
        // Make sure clicked element is our toggle
        const el = /** @type {HTMLElement} */ (event.target);

        if (!el.classList.contains("js-show-unavailable")) {
            return;
        }

        // Prevent default link behavior
        event.preventDefault();

        // Get target of input to clear
        let els = document.querySelector("input[name='show_unavailable']");

        // Adding null check to prevent "Cannot read properties of null (reading 'closest')" error, although I can't find this input anywhere in the code
        if (els !== null) {
            els.closest(".facet__detail").classList.remove("d-none");
            simulateClick(els);
        }
    },
    false
);

if (document.querySelectorAll(".js-filter-show-more").length > 0) {
    const list = document.querySelectorAll(".js-filter-show-more");

    list.forEach((element) => {
        element.addEventListener("click", function (event) {
            const el = event.target;
            const list = document.querySelectorAll(`.${el.dataset.target}`);
            const hiddenList = el.dataset.list;

            list.forEach((element) => {
                // Check both data-region-id (for regions) and data-filter-id (for filters)
                const elementId = element.dataset.regionId || element.dataset.filterId;

                if (
                    hiddenList.indexOf(elementId) > -1
                ) {
                    if (el.dataset.show == "true") {
                        element.classList.remove("d-none");
                    } else {
                        element.classList.add("d-none");
                    }
                }
            });

            const text = el.innerText;
            el.innerText = el.dataset.text;
            el.dataset.text = text;
            el.dataset.show = !(el.dataset.show == "true");
        });
    });
}

// Define the debounced function at the top level, outside the event listener
const debouncedTrackClick = debounce((searchEventId, propertyId, clickTime) => {
    const data = {
        search_event_id: searchEventId,
        property_id: parseInt(propertyId),
        click_time: clickTime
    };

    // Use fetch with keepalive to ensure tracking request completes even when page navigates away
    fetch('/api/analytics/track/click/property', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        keepalive: true
    });
}, 300);

document.addEventListener("click", function (event) {
    let el = /** @type {HTMLElement} */ (event.target);

    while (el && !el.classList.contains("js-establishment-click")) {
        el = el.parentElement;
    }

    if (!el) {
        return;
    }

    const propertyId = el.getAttribute('data-property-id');
    const searchEventId = window.tg.search_event_id;
    const clickTime = new Date().toISOString();

    if (!searchEventId) return;

    if (propertyId) {
        debouncedTrackClick(searchEventId, propertyId, clickTime);
    }
});

document.addEventListener("click", function (event) {
    // Make sure clicked element is our toggle
    const el = /** @type {HTMLElement} */ (event.target);

    if (
        !el.classList.contains("js-page-link") &&
        !el.classList.contains("js-next-link")
    ) {
        return;
    }

    event.preventDefault();
    const moveTo = new MoveTo({
        tolerance: infiniteLoad ? 100 : 0,
        duration: 50,
        easing: "easeOutQuart",
        container: window,
    });
    moveTo.move(document.getElementById("section-top"));
    fetchResults("search", "", el.dataset.page);
});

document.addEventListener("click", function (event) {
    // Make sure clicked element is our toggle
    const el = /** @type {HTMLElement} */ (event.target);

    if (!el.classList.contains("js-clear-filters")) {
        return;
    }

    event.preventDefault();
    const moveTo = new MoveTo({
        tolerance: infiniteLoad ? 100 : 0,
        duration: 50,
        easing: "easeOutQuart",
        container: window,
    });

    resetFilters();
    moveTo.move(document.getElementById("section-top"));
    fetchResults("clear-filters", "clear-filters", 1);
});

document.addEventListener("click", function (event) {
    const el = /** @type {HTMLElement} */ (event.target);

    if (!el.classList.contains("js-extend-my-dates")) {
        return;
    }

    const store = Alpine.store('search');
    store.extendDates = true;
    let teleportTo = is_mobile_device ? 'MOBILE' : Alpine.store('general').sticky.bar ? 'BAR' : 'DESKTOP';

    Alpine.nextTick(() => {
            if (Alpine.store('general').openSection !== 'SEARCH') {
                Alpine.store('general').updateOpenSection('SEARCH');
            }
            Alpine.store('general').updateSearchTeleport(teleportTo);
        setTimeout(() => {
            Alpine.store('search').activeSection = 'start';
            toggleMobileTraySort(event);
        }, 250);
    });
});

document.addEventListener("click", function (event) {
    // Make sure clicked element is our toggle
    const el = /** @type {HTMLElement} */ (event.target);

    if (!el.classList.contains("js-clear-all")) {
        return;
    }

    event.preventDefault();
    const moveTo = new MoveTo({
        tolerance: infiniteLoad ? 100 : 0,
        duration: 50,
        easing: "easeOutQuart",
        container: window,
    });

    resetFilters();
    moveTo.move(document.getElementById("section-top"));
    fetchResults("clear-all", "clear-all", 1);
});

document.addEventListener("click", function (event) {
    // Make sure clicked element is pensioner banner
    const el = /** @type {HTMLElement} */ (event.target);

    if (!el.classList.contains("js-pensioner-pricing")) {
        return;
    }

    event.preventDefault();

    // Toggle pensioner session
    let pensionerSpecial = form.querySelector('input[name="pensioner_specials"]');
    if (pensionerSpecial) {
        simulateClick(pensionerSpecial);
    }
});

document.addEventListener("click", function (event) {
    // Make sure clicked element is pensioner session checkbox
    const el = /** @type {HTMLElement} */ (event.target);

    if (!(el.id === "Filter-User-Type-Pensioner")) {
        return;
    }

    if (el.checked === true) {
        return;
    }

    // Uncheck "Special Type Filter - Pensioner"
    let specialTypeFilter = form.querySelector('input[name="specials_type_filter"][value="pensioner"]');
    if (specialTypeFilter) {
        specialTypeFilter.checked = false;
    }
});

document.addEventListener("click", function (event) {
    // Make sure clicked element is Filter by Special Type - Pensioner
    const el = /** @type {HTMLElement} */ (event.target);

    if (!(el.name === "specials_type_filter" && el.value === "pensioner")) {
        return;
    }

    if (el.checked === false) {
       return;
    }

    let pensionerInput = form.querySelector('#Filter-User-Type-Pensioner')

    if (!pensionerInput.checked) { // No pensioner session
        pensionerInput.checked = true; // Add pensioner session
    }
});

const modal = document.getElementById('js-modal')

document.addEventListener("click", function (event) {
    // Make sure clicked element is the share button
    const el = /** @type {HTMLElement} */ (event.target);

    if (!(el.classList.contains("js-share-results-icon") || el.classList.contains("js-share-results-btn"))) {
        return;
    }

    event.preventDefault();
    shareResultsLink();
});

function shareResultsLink() {
    if (window.document.documentMode) {
        return;
    }

    const url = new URL(document.URL);

    // Get applied filters and add them to the url if not already there
    filterData = serializeForm(form);
    let shareURL = url.href;
    let hasParams = shareURL.includes('?');

    for (let [key, value] of Object.entries(filterData)) {
        if (!shareURL.includes(key)) {
            shareURL += (hasParams ? '&' : '?') + key + '=' + value;
        }

        hasParams = shareURL.includes('?');
    }

    let mobile = true;
    if (typeof is_mobile_device !== 'undefined' && is_mobile_device == false) {
        mobile = false;
    }

    let options = {
        text: language_switch == 'af' ? 'Kyk gerus na hierdie lekke plekke op ' + site_name + ':' : 'Check out these great places on ' + site_name + ':',
        url: shareURL,
    }

}

// Viya results page mobile sticky header - logic for showing/hiding the logo above the search form
if (site == 'vy' && is_mobile_device && 'IntersectionObserver' in window) {
    let headerLogo = document.getElementById('js-results-header-logo')
    if (headerLogo) {
        let headerLogoHeight = headerLogo.getBoundingClientRect().height
        let headerContainer = document.getElementById('js-header')

        // Observe element at end of results header and hide logo when user scrolls past
        const scrollObserver = new IntersectionObserver(function (entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Show logo
                    headerLogo.style.display = 'flex'
                    // Remove extra padding
                    headerContainer.style.paddingBottom = '0'
                } else {
                    // Hide logo
                    headerLogo.style.display = 'none'
                    // Add extra padding equal to the height of the logo container to avoid page jumping
                    headerContainer.style.paddingBottom = `${headerLogoHeight}px`
                }
            })
        });
        scrollObserver.observe(document.getElementById('js-results-header-end'));
    }
}

document.addEventListener('keyup', function(event) {
    const el = /** @type {HTMLElement} */ (event.target);

    if (!(el.classList.contains("js-collection-caption"))) {
        return;
    }

    updateCaptionCharacterLength()
})

function updateCaptionCharacterLength() {
    let charDiv = document.querySelector("#js-collection-caption-length-div")
    let charCountElement = document.querySelector("#js-collection-caption-length-count")
    const captionElement = document.querySelector("textarea[name='caption']")
    const captionFormGroup = document.querySelector("#js-caption-form-group")
    const captionError = document.querySelector("#js-collection-caption-error")
    let currentCharCount = captionElement.value.length

    charCountElement.innerHTML = 500 - currentCharCount

    if (currentCharCount > 450) {
        charDiv.classList.add('text-error')
    } else {
        charDiv.classList.remove('text-error')
    }

    let submitBtn = document.querySelector('.js-update-button')
    if (currentCharCount > 500) {
        captionFormGroup.classList.add('has-error')
        charDiv.classList.add('d-none')
        captionError.classList.remove('d-none')
        submitBtn.disabled = true;
        submitBtn.classList.add('disabled');
    } else {
        captionFormGroup.classList.remove('has-error')
        charDiv.classList.remove('d-none')
        captionError.classList.add('d-none')
        submitBtn.disabled = false;
        submitBtn.classList.remove('disabled');
    }
}
